
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Purchase } from "@/lib/purchases";

export function useSuccessRedirect(
  courseId: string | null,
  purchase: Purchase | null
) {
  const navigate = useNavigate();

  // If we have a course ID and payment was successful, redirect to learner course after 10s
  useEffect(() => {
    if (
      courseId &&
      purchase &&
      (purchase.payment_status === "completed" ||
        purchase.status === "completed")
    ) {
      const timer = setTimeout(() => {
        navigate(`/learner/course/${courseId}`);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [courseId, navigate, purchase]);

  return null;
}
